import React, { useState } from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import IndexMiddleHome from "./IndexMiddleHome";
import IndexMiddleOffice from "./IndexMiddleOffice";
import IndexMiddleOutdoor from "./IndexMiddleOutdoor";
import { useTranslation } from "react-i18next";

import PinkBar from "../PinkBar";

const useStyles = makeStyles({
  miniLink: {
    paddingLeft: "10px",
    paddingRight: "10px",
    color: "#263238",
    cursor: "pointer",
    position: "relative",
    top: "+17px",
  },
  miniLinkCursor: {
    paddingLeft: "10px",
    paddingRight: "10px",
    cursor: "pointer",
    color: "black",
    fontWeight: 600,
    borderBottom: "3px solid black",
    paddingBottom: "10px",
    position: "relative",
    top: "+17px",
  },
});

const IndexMiddle = () => {
  const [clickedItem, setClickedItem] = useState(1);
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const changeDisplay = (num) => {
    setClickedItem(num);
  };
  let show;
  if (clickedItem === 1) {
    show = <IndexMiddleHome />;
  } else if (clickedItem === 2) {
    show = <IndexMiddleOffice />;
  } else {
    show = <IndexMiddleOutdoor />;
  }
  return (
    <Box
      sx={{
        width: { md: 7 / 10, sm: 1 },
        py: 8,
        px: { md: 4, sm: 2, xs: 1 },
        ml: "auto",
        mr: "auto",
      }}
    >
      <PinkBar title={t("indexNano")} pt="24px" subtitle={t("indexMiddle")} />

      <Box
        sx={{
          borderBottom: "1px solid gray",
          pt: 8,
          pb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            textTransform: "uppercase",
            width: { md: 1 / 2 },
            ml: "auto",
            mr: "auto",
            justifyContent: "space-between",
          }}
        >
          <Box
            className={
              clickedItem === 1 ? classes.miniLinkCursor : classes.miniLink
            }
            onClick={() => changeDisplay(1)}
          >
            {t("for_home")}
          </Box>
          <Box
            className={
              clickedItem === 2 ? classes.miniLinkCursor : classes.miniLink
            }
            onClick={() => changeDisplay(2)}
          >
            {t("for_office")}
          </Box>
          <Box
            className={
              clickedItem === 3 ? classes.miniLinkCursor : classes.miniLink
            }
            onClick={() => changeDisplay(3)}
          >
            {t("for_outdoor")}
          </Box>
        </Box>
      </Box>
      <Box>{show}</Box>
    </Box>
  );
};

export default IndexMiddle;
